import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Image,
  InputNumber,
  Affix,
  Button,
  message,
  DatePicker,
  Space,
  Select,
  Input,
} from "antd";
import {
  getContactSearchResultbyPhone,
  getSpecificContact,
} from "../../../actions/contactAction";
import { getSpecificMeasurementbycontact } from "../../../actions/measurment";
import { getCuponSearchResult } from "../../../actions/cupon";
import CreateNewContct from "../CreateNewContct";
import { NotificationFilled } from "@ant-design/icons";
import dateFormat from "dateformat";

const Demo = ({
  getContactSearchResultbyPhone,
  getSpecificMeasurementbycontact,
  getSpecificContact,
  getCuponSearchResult,
  bill,
  setCart,
  id,
}) => {
  const [showsuggetion, setshowsuggetion] = useState(false);
  const [contactsuggetions, setcontactsuggetions] = useState([]);
  const [contact, setcontact] = useState({});
  const [remove, setremove] = useState(false);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (id > 0) {
      getSpecificContact(id).then((response) => {
        if (typeof response != "undefined") {
          getSpecificMeasurementbycontact(id).then((measurement) => {
            if (typeof measurement != "undefined") {
              bill.current.basicmeasurement = measurement[0];
            }
            setcontact(response);
            bill.current.Contact = response.id;
            if (parseFloat(response.account_balance) > 0) {
              bill.current.Payable = parseFloat(response.account_balance);
            } else {
              bill.current.Payable = 0;
            }
            setshowsuggetion(false);
            setremove(true);
            setCart(true);
          });
        }
      });
    }
  }, [id, getSpecificContact, getSpecificMeasurementbycontact, bill, setCart]);

  // const onChange = (e) => {
  //   const value = e.target.value;
  //   if (value) {
  //     getContactSearchResultbyPhone(value).then((result) => {
  //       setcontactsuggetions(result);
  //       setshowsuggetion(true);
  //     });
  //   } else {
  //     setshowsuggetion(false);
  //   }
  // };
  
  const onChange = (e) => {
    const value = e.target.value;

    if (timer) {
      clearTimeout(timer);
    }

    if (value.length === 2) {
      setTimer(
        setTimeout(() => {
          getContactSearchResultbyPhone(value).then((result) => {
            setcontactsuggetions(result);
            setshowsuggetion(true);
          });
        }, 2000)
      );
    } else if (value.length > 2) {
      getContactSearchResultbyPhone(value).then((result) => {
        setcontactsuggetions(result);
        setshowsuggetion(true);
      });
    } else {
      setshowsuggetion(false);
    }
  };

  const renderContact = () => {
    if (showsuggetion) {
      return contactsuggetions.map((contact, index) => {
        if (contact.Type == "Customer" && index < 10) {
          return (
            <Row
              key={contact.id}
              style={{
                border: "1px solid lightgray",
                padding: "5px",
                marginBottom: "1px",
                borderRadius: "5px",
              }}
              onClick={() => {
                setcontact(contact);
                getCuponSearchResult(contact.Cupon).then((result) => {
                  if (result.length === 1 && result[0].status === "Active") {
                    if (
                      (result[0].limit_type === "limited" &&
                        result[0].limit > 0) ||
                      result[0].limit_type === "Unlimited"
                    ) {
                      const currentdate = new Date();

                      const d1 = dateFormat(
                        result[0].start,
                        "yyyy-mm-dd HH:MM:ss"
                      );
                      const d2 = dateFormat(result[0].end, "yyyy-mm-dd HH:MM:ss");
                      const current = dateFormat(
                        currentdate,
                        "yyyy-mm-dd HH:MM:ss"
                      );
                      const date1 = new Date(d1);
                      const date2 = new Date(d2);
                      const currenttime = new Date(current);

                      const diff1 = currenttime.getTime() - date1.getTime();
                      const diff2 = date2.getTime() - currenttime.getTime();
                      const lte = diff1 / (1000 * 3600 * 24);
                      const gte = diff2 / (1000 * 3600 * 24);

                      if (lte >= 0 && gte >= 0) {
                        message.success("Coupon has been applied");
                        bill.current.Cupon = result[0];
                        setCart(true);
                      }
                    }
                  }
                });

                bill.current.Contact = contact.id;
                if (parseFloat(contact.account_balance) > 0) {
                  bill.current.Payable = parseFloat(contact.account_balance);
                } else {
                  bill.current.Payable = 0;
                }

                setshowsuggetion(false);
                setremove(true);
                setCart(true);
              }}
            >
              <Col span={17}>
                <h4 style={{ paddingLeft: "5px", paddingRight: "5px" }}>
                  {contact.name}
                </h4>
              </Col>
              <Col span={6}>{contact.phone}</Col>
            </Row>
          );
        }
        return null;
      });
    }
  };

  return (
    <>
      {remove ? (
        <Button
          onClick={() => {
            setremove(false);
            setcontact(null);
            bill.current.Payable = 0;
            bill.current.Contact = null;
            setCart(true);
          }}
          type="link"
        >
          remove contact
        </Button>
      ) : (
        <Space direction="Horizontal" style={{ width: "90%" }}>
          <Input
            placeholder="Enter Phone Number to select contact"
            onChange={onChange}
            width="60"
          />
          <CreateNewContct bill={bill} setcontact={setcontact} />
        </Space>
      )}
      <div
        style={{
          position: "absolute",
          zIndex: "5",
          backgroundColor: "#F5F5F5",
          width: "70%",
        }}
      >
        {renderContact()}
      </div>
      <br />
      {contact && (
        <>
          {contact.name && <h1>{contact.name}</h1>}
          {contact.role && (
            <>
              {contact.Role}
              <br />
            </>
          )}
          {contact.address && (
            <>
              {contact.address}
              <br />
            </>
          )}
          {contact.phone && `Phone : ${contact.phone}`}
        </>
      )}
    </>
  );
};

export default connect(null, {
  getContactSearchResultbyPhone,
  getSpecificContact,
  getSpecificMeasurementbycontact,
  getCuponSearchResult,
})(Demo);
